import { render } from "./Auth.vue?vue&type=template&id=6df9aaca&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"

import "./Auth.vue?vue&type=style&index=0&id=6df9aaca&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6df9aaca"

export default script